import { useEffect, useState } from 'react';
import InputField from '../../../../../../component/form/FormInput';
import InputSelect from '../../../../../../component/inputSelect/InputSelect';
import Modal from '../../../../../../component/modal/Modal';
import usePaymentMethod from '../../../../../purchasebills/hooks/usePaymentMethod';
import AddPaymentMethodModal from '../../../../../purchasebills/components/AddPaymentMethodModal';
import { getCurrentDate } from '../../../../../../utils/dateUtils';
import Button from '../../../../../../component/ui/Button';
import PaymentReceivedTable from '../../../paymentReceieved/components/paymentReceivedTable';
import { toast } from 'react-toastify';
import {
	createPaymentsReceived,
	fetchPaymentReceivedNumber,
} from '../../../../../../services/payments_received';
import ExcessPaymentModal from '../../../paymentReceieved/components/excessPaymentModal';

const RecordPaymentModel = ({
	invoiceDetails,
	isRecordPaymentModalOpen,
	setIsRecordPaymentModalOpen,
	getInvoiceDetails,
}) => {
	const { paymentMethodList, setSearchPaymentMethod } = usePaymentMethod();
	const [error, setError] = useState({});
	const [depositToList, setDepositToList] = useState([{ key: 1, value: 'Sale' }]);
	const [isPaymentMethodFocus, setIsPaymentMethodFocus] = useState(false);
	const [isAddPaymentMethod, setIsAddPaymentMethod] = useState(false);
	const [isOpenPastDate, setIsOpenPastDate] = useState(false);
	const [isUsedPastDate, setIsUsedPastDate] = useState(false);
	const [isDateFocus, setIsDateFocus] = useState(true);
	const [isLoading, setLoading] = useState(false);
	const [errorCells, setErrorCells] = useState([]);
	const [isExcessPaymentModalOpen, setIsExcessPaymentModalOpen] = useState(false);
	const [recordPayment, setRecordPayment] = useState({
		customer_id: invoiceDetails?.customer_id,
		payment_receive_number: 'PR-001',
		date: getCurrentDate(),
		payment_method: invoiceDetails?.payment_method_id,
		received_payment_amount: null,
		deposit_to_id: 1,
		notes: '',
	});

	const [recordPaymentProductList, setRecordPaymentProductList] = useState([]);
	const handlePaymentChange = (index, value) => {
		const paymentsData = [...recordPaymentProductList];
		paymentsData[index].payment_amount = value;
		setRecordPaymentProductList(paymentsData);
		const isValid = Number(paymentsData[index].due_amount) >= Number(value);
		setErrorCells((prev) => {
			const filtered = prev.filter((error) => error.index !== index);

			return isValid ? filtered : [...filtered, { index, error: 'Invalid Payment' }];
		});
	};

	const handleFullPaymentToggle = (index, type) => {
		if (type === 'pay') {
			if (Number(recordPayment?.received_payment_amount || 0) > 0) {
				const paymentAmount = recordPaymentProductList?.reduce(
					(total, bill) => Number(total) + Number(bill.payment_amount),
					0,
				);
				if (
					Number(recordPayment?.received_payment_amount) - Number(paymentAmount) >
					Number(recordPaymentProductList[index].due_amount)
				) {
					const paymentBillsData = [...recordPaymentProductList];
					paymentBillsData[index].payment_amount = paymentBillsData[index].due_amount;
					setRecordPaymentProductList(paymentBillsData);
				} else {
					const paymentBillsData = [...recordPaymentProductList];
					paymentBillsData[index].payment_amount =
						Number(recordPayment?.received_payment_amount) - Number(paymentAmount);
					setRecordPaymentProductList(paymentBillsData);
				}
			} else {
				var newError = { ...error };
				newError.received_payment_amount = 'Please enter payment received amount in the field';
				setError(newError);
			}
		} else {
			const paymentBillsData = [...recordPaymentProductList];
			paymentBillsData[index].payment_amount = 0.0;
			setRecordPaymentProductList(paymentBillsData);
		}
	};

	const calculateTotalPayment = () => {
		return recordPaymentProductList?.reduce(
			(total, bill) => Number(total) + Number(bill.payment_amount),
			0,
		);
	};

	const calculateExcessPayment = () => {
		var amount = recordPaymentProductList?.reduce(
			(total, bill) => Number(total) + Number(bill.payment_amount),
			0,
		);
		return Number(recordPayment?.received_payment_amount ?? 0) - Number(amount);
	};

	function handleFormData(type, value) {
		setRecordPayment((prev) => ({
			...prev,
			[type]: value,
		}));
		let newError = { ...error };
		if (type === 'customer_id') {
			if (value === '' || value === null || value === undefined) {
				newError[type] = 'Please select valid  customer name from the list';
			} else {
				delete newError[type];
			}
		}

		if (type === 'payment_method') {
			if (value === '' || value === null || value === undefined) {
				newError[type] = 'Please select valid  payment method from the list';
			} else {
				delete newError[type];
			}
		}
		if (type === 'received_payment_amount') {
			if (value === '' || value === null || value === undefined) {
				newError[type] = 'Please enter amount received in the field';
			} else {
				delete newError[type];
			}
		}
		setError(newError);
	}

	function handleClearAppliedAmount() {
		const paymentsData = recordPaymentProductList.map((item) => ({
			...item,
			payment_amount: '',
		}));
		setRecordPaymentProductList(paymentsData);
	}

	const checkValidation = () => {
		let newError = { ...error };
		let newTableError = [...errorCells];
		if (
			!recordPayment.customer_id ||
			recordPayment.customer_id === '' ||
			recordPayment.customer_id === undefined
		) {
			newError.customer_id = 'Please select a valid customer from the list.';
		} else {
			delete newError.customer_id;
		}

		if (
			!recordPayment.payment_receive_number ||
			recordPayment.payment_receive_number === '' ||
			recordPayment.payment_receive_number === undefined
		) {
			newError.payment_receive_number = 'Please enter payment receive number in the field';
		} else {
			delete newError.payment_receive_number;
		}

		if (
			!recordPayment.date ||
			recordPayment.date === '' ||
			recordPayment.date === undefined ||
			(recordPayment.date !== '' && newError.date)
		) {
			newError.date = newError.date ?? 'Please enter payment date in the field';
		} else {
			delete newError.date;
		}

		if (
			!recordPayment.payment_method ||
			recordPayment.payment_method === '' ||
			recordPayment.payment_method === undefined
		) {
			newError.payment_method = 'Please select a valid payment method from the list.';
		} else {
			delete newError.payment_method;
		}

		if (
			!recordPayment.received_payment_amount ||
			recordPayment.received_payment_amount === '' ||
			recordPayment.received_payment_amount === undefined ||
			(recordPayment.received_payment_amount !== '' && newError.received_payment_amount)
		) {
			newError.received_payment_amount = 'Please enter payment received amount in the field';
		} else {
			delete newError.received_payment_amount;
		}

		if (
			Object.keys(newError).length > 0 ||
			newTableError.length > 0 ||
			calculateExcessPayment() < 0
		) {
			setError(newError);
			setErrorCells(newTableError);
			return true;
		} else {
			return false;
		}
	};
	const HandleSaveReceivePayment = async (status, isCreditNote = false) => {
		const isErrorShow = checkValidation(status);
		if (isErrorShow) {
			if (calculateExcessPayment() < 0) {
				toast.error('Payment Amount should not greater than amount received.');
			} else {
				toast.error('Please fill all mandatory fields before saving');
			}
		} else {
			try {
				setLoading(true);
				const body = {
					customer_id: recordPayment?.customer_id,
					organisation_id: invoiceDetails?.customer?.organisation_id,
					payment_receive_number: recordPayment?.payment_receive_number,
					date: recordPayment?.date,
					payment_mode_id: recordPayment?.payment_method,
					received_payment_amount: recordPayment?.received_payment_amount,
					deposit_to_id: 1,
					notes: recordPayment?.notes,
					status: status,
					used_payment_amount: calculateTotalPayment(),
					excess_payment_amount: calculateExcessPayment().toFixed(2),
					sales_payment_receives_invoices: recordPaymentProductList,
				};
				const res = await createPaymentsReceived(body);
				if (res?.success) {
					toast.success('Record Payments Created Successfully');
					if (isCreditNote) {
					}
					setIsRecordPaymentModalOpen(false);
					getInvoiceDetails();
				} else {
					toast.error(error.message ?? 'something went wrong');
				}
			} catch (error) {
				toast.error(error.message ?? 'something went wrong');
			} finally {
				setLoading(false);
			}
		}
	};

	const confirmUsedPastDate = () => {
		const newError = { ...error };
		delete newError.date;
		setError(newError);
		setIsUsedPastDate(true);
		setIsOpenPastDate(false);
		setIsPaymentMethodFocus(true);
	};

	const cancelUsedPastDate = () => {
		setIsOpenPastDate(false);
		setIsDateFocus(true);
	};

	useEffect(() => {
		if (recordPaymentProductList.length === 0) {
			setRecordPaymentProductList([
				{
					id: invoiceDetails?.id,
					invoice_number: invoiceDetails?.invoice_number,
					due_amount: invoiceDetails?.due_amount,
					date: invoiceDetails?.date,
					due_date: invoiceDetails?.due_date,
					amount: invoiceDetails?.total_amount,
					payment_amount: 0.0,
				},
			]);
		}
	}, [recordPaymentProductList]);

	async function handleFetchInvoiceNumber() {
		try {
			const pr = await fetchPaymentReceivedNumber();
			handleFormData('payment_receive_number', pr?.number);
		} catch (error) {
			toast.error(error.message ?? 'Something went wrong!');
		}
	}

	useEffect(() => {
		handleFetchInvoiceNumber();
	}, []);

	return (
		<Modal
			isOpen={isRecordPaymentModalOpen}
			title={``}
			className={'recordPaymentModel'}
		>
			<div>
				<div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: '10px' }}>
					<div style={{ display: 'flex', flexDirection: 'column' }}>
						<div style={{ fontSize: '20px', fontWeight: '600', color: '#000' }}>
							{`Receive Payment For ${invoiceDetails?.customer?.name}`}
						</div>
						<div style={{ fontSize: '16px', fontWeight: '600', color: '#000' }}>
							{`Invoice# ${invoiceDetails?.invoice_number}`}
						</div>
					</div>
					<InputField
						label="Payment #"
						placeholder="Payment#"
						onChange={(value) => {}}
						value={recordPayment?.payment_receive_number}
						required={true}
						disabled={true}
						error={error.payment_receive_number}
					/>
				</div>
				<div
					className="row"
					style={{ marginTop: '5px' }}
				>
					<div className="col-2">
						<InputField
							label="Payment Date"
							placeholder="Enter Date"
							type="date"
							required={true}
							error={error?.date}
							autoFocus={isDateFocus}
							value={recordPayment?.date}
							onBlur={(e) => {
								var value = e.target.value;
								const newError = { ...error };
								var date = new Date(value);
								var currentDate = new Date();
								currentDate.setDate(currentDate.getDate() + 1);
								let year = date.getFullYear().toString();
								if (year.length === 4 && new Date(value) < new Date().setHours(0, 0, 0, 0)) {
									if (!isUsedPastDate) {
										setIsOpenPastDate(true);
										newError.date = 'Date cannot be in the past.';
										setError(newError);
									} else {
										delete newError.date;
										setError(newError);
									}
									setRecordPayment((prev) => ({
										...prev,
										date: value,
									}));
								} else if (
									year.length === 4 &&
									new Date(value) > currentDate.setHours(0, 0, 0, 0)
								) {
									setIsOpenPastDate(false);
									newError.date = 'Date cannot be in the future';
									setError(newError);
									setRecordPayment((prev) => ({
										...prev,
										date: value,
									}));
								} else {
									setRecordPayment((prev) => ({
										...prev,
										date: value,
									}));
									setIsOpenPastDate(false);
									delete newError.date;
									setError(newError);
								}
							}}
							onChange={(value) => {
								const newError = { ...error };
								var date = new Date(value);
								var currentDate = new Date();
								currentDate.setDate(currentDate.getDate() + 1);
								let year = date.getFullYear().toString();
								if (year.length === 4 && new Date(value) < new Date().setHours(0, 0, 0, 0)) {
									newError.date = 'Date cannot be in the past.';
									setError(newError);
									setRecordPayment((prev) => ({
										...prev,
										date: value,
									}));
								} else if (
									year.length === 4 &&
									new Date(value) > currentDate.setHours(0, 0, 0, 0)
								) {
									setIsOpenPastDate(false);
									newError.date = 'Date cannot be in the future';
									setError(newError);
									setRecordPayment((prev) => ({
										...prev,
										date: value,
									}));
								} else {
									setRecordPayment((prev) => ({
										...prev,
										date: value,
									}));
									setIsOpenPastDate(false);
									delete newError.date;
									setError(newError);
								}
							}}
							max={getCurrentDate()}
						/>
					</div>
					<div className="col-2">
						<InputSelect
							options={paymentMethodList}
							label="Payment Mode"
							placeholder="Payment Mode"
							required={true}
							name="payment_mode"
							autoFocus={isPaymentMethodFocus}
							value={recordPayment.payment_method}
							onChange={(value) => {
								if (value === '' || value === null) {
									handleFormData('payment_method', value);
								}
								setSearchPaymentMethod(value);
							}}
							onSelect={(options) => {
								handleFormData('payment_method', options?.key);
							}}
							error={error?.payment_method}
							onAddNew={() => {
								setIsAddPaymentMethod(true);
								setIsPaymentMethodFocus(false);
							}}
						/>
					</div>
					<div style={{ width: '160px' }}>
						<InputField
							label="Amount Received"
							placeholder="Enter Amount Received"
							onChange={(valueData) => {
								var value = valueData?.replace(/[^0-9.]/g, '');
								handleFormData('received_payment_amount', value);
							}}
							value={recordPayment?.received_payment_amount}
							required={true}
							error={error?.received_payment_amount}
						/>
					</div>
					<div className="col-2">
						<InputSelect
							options={depositToList}
							label="Deposit To"
							placeholder="Deposit To"
							required={false}
							name="deposit to"
							autoFocus={false}
							value={recordPayment.deposit_to_id}
							onChange={(value) => {}}
							onSelect={(options) => {}}
							disabled={true}
						/>
					</div>
					<div className="col">
						<InputField
							label="Notes / Reference"
							placeholder="Ref-000065"
							onChange={(value) => {
								handleFormData('notes', value);
							}}
							value={recordPayment?.notes}
						/>
					</div>
				</div>

				<div>
					<PaymentReceivedTable
						isDisabled={false}
						tableColumns={['Date', 'Invoice Number', 'Invoice Amount', 'Amount Due', 'Payment']}
						handleClearAppliedAmount={handleClearAppliedAmount}
						errors={errorCells}
						productTableData={recordPaymentProductList}
						handlePaymentChange={handlePaymentChange}
						handleFullPaymentToggle={handleFullPaymentToggle}
						calculateTotalPayment={calculateTotalPayment}
						type={'pr'}
					/>

					<div
						style={{
							padding: '10px 0px',
							float: 'right',
							margin: '10px 0px',
						}}
					>
						<div
							className="d-flex"
							style={{ justifyContent: 'flex-end' }}
						>
							<div style={{ color: '#000000', fontWeight: '600', textAlign: 'right' }}>
								<p>Amount Paid</p>
								<p>Amount Used For Payment</p>
								<p style={{ display: 'flex', paddingLeft: '40px' }}>
									<svg
										width="18"
										height="18"
										viewBox="0 0 18 18"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M7.71758 2.89393L1.36508 13.4989C1.2341 13.7258 1.1648 13.9829 1.16407 14.2448C1.16334 14.5067 1.23119 14.7643 1.3609 14.9918C1.4906 15.2194 1.67762 15.409 1.90336 15.5418C2.12909 15.6746 2.38568 15.7461 2.64758 15.7489H15.3526C15.6145 15.7461 15.8711 15.6746 16.0968 15.5418C16.3225 15.409 16.5096 15.2194 16.6393 14.9918C16.769 14.7643 16.8368 14.5067 16.8361 14.2448C16.8354 13.9829 16.7661 13.7258 16.6351 13.4989L10.2826 2.89393C10.1489 2.67351 9.96062 2.49127 9.73597 2.3648C9.51133 2.23832 9.25788 2.17188 9.00008 2.17188C8.74228 2.17188 8.48882 2.23832 8.26418 2.3648C8.03954 2.49127 7.85128 2.67351 7.71758 2.89393Z"
											stroke="#BF9A18"
											stroke-width="2"
											stroke-linecap="round"
											stroke-linejoin="round"
										/>
										<path
											d="M9 6.75V9.75"
											stroke="#BF9A18"
											stroke-width="2"
											stroke-linecap="round"
											stroke-linejoin="round"
										/>
										<path
											d="M9 12.75H9.0075"
											stroke="#BF9A18"
											stroke-width="2"
											stroke-linecap="round"
											stroke-linejoin="round"
										/>
									</svg>
									Amount Excess
								</p>
							</div>
							<div style={{ marginLeft: '35px', fontWeight: '600' }}>
								<p>₹ {Number(recordPayment.received_payment_amount || 0.0) || 0.0}/-</p>
								<p>₹ {calculateTotalPayment()?.toFixed(2) || 'N/A'}/-</p>
								<p>₹ {calculateExcessPayment().toFixed(2)}/-</p>
							</div>
						</div>
					</div>
					<div style={{ clear: 'both' }}></div>
				</div>
				<div
					style={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						gap: 12,
						marginTop: '10px',
					}}
				>
					<Button
						type="button"
						className="mt-0 btn-primary add-pro"
						button="Receive Payment"
						loader={isLoading}
						onClick={() => {
							if (!isLoading) {
								if (calculateExcessPayment().toFixed(2) > 0) {
									setIsExcessPaymentModalOpen(true);
								} else {
									HandleSaveReceivePayment(3, false);
								}
							}
						}}
					/>
					<Button
						type="button"
						className="mt-0 btn-danger add-pro"
						button="Cancel"
						onClick={() => setIsRecordPaymentModalOpen(false)}
					/>
				</div>
				{isOpenPastDate && (
					<Modal
						className="delivery-modal"
						title="Confirm Past Date"
						isOpen={isOpenPastDate}
						onClose={() => cancelUsedPastDate()}
						cancelButton={true}
					>
						<p>You are creating a transaction in the past date. Do you want to continue?</p>

						<div
							style={{
								display: 'flex',
								flexDirection: 'row',
								justifyContent: 'flex-start',
								marginTop: '20px',
							}}
						>
							<Button
								button="Proceed"
								type="button"
								className="btn btn-primary"
								onClick={confirmUsedPastDate}
							/>
							<span style={{ width: '20px' }}></span>
							<Button
								button="Cancel"
								type="button"
								className="btn btn-danger"
								onClick={() => cancelUsedPastDate()}
							/>
						</div>
					</Modal>
				)}
				{isAddPaymentMethod && (
					<AddPaymentMethodModal
						type={'Payment Method'}
						isAddPaymentMethod={isAddPaymentMethod}
						setIsAddPaymentMethod={setIsAddPaymentMethod}
						setIsPaymentMethodFocus={setIsPaymentMethodFocus}
						setPurchaseBillFormData={setRecordPayment}
					/>
				)}
				{isExcessPaymentModalOpen && (
					<ExcessPaymentModal
						isModalOpen={isExcessPaymentModalOpen}
						setIsModelOpen={setIsExcessPaymentModalOpen}
						handleCreditNote={() => HandleSaveReceivePayment(2, true)}
						handleLater={() => HandleSaveReceivePayment(0, false)}
						handlePaymentReceived={() => HandleSaveReceivePayment(1, false)}
						excessAmount={calculateExcessPayment().toFixed(2)}
					/>
				)}
			</div>
		</Modal>
	);
};
export default RecordPaymentModel;
